export type CategoryId =
  | "music"
  | "food"
  | "art"
  | "market"
  | "cinema"
  | "outdoor"
  | "cafe"
  | "queer"
  | "sports"
  | "hidden";

export const CATEGORY_IDS: readonly CategoryId[] = [
  "music",
  "food",
  "art",
  "market",
  "cinema",
  "outdoor",
  "cafe",
  "queer",
  "sports",
  "hidden",
] as const;

export interface Category {
  id: CategoryId | "all";
  label: string;
  color: string;
}

export const MA_CATS: Record<CategoryId | "all", Category> = {
  all: { id: "all", label: "All", color: "var(--ma-ink)" },
  music: { id: "music", label: "Music", color: "var(--ma-brick)" },
  food: { id: "food", label: "Food & Drink", color: "var(--ma-mustard)" },
  art: { id: "art", label: "Art", color: "var(--ma-canal)" },
  market: { id: "market", label: "Markets", color: "var(--ma-mustard)" },
  cinema: { id: "cinema", label: "Cinema", color: "var(--ma-pink)" },
  outdoor: { id: "outdoor", label: "Outdoors", color: "var(--ma-canal)" },
  cafe: { id: "cafe", label: "Cafés", color: "var(--ma-mustard)" },
  queer: { id: "queer", label: "Queer", color: "var(--ma-pink)" },
  sports: { id: "sports", label: "Sports", color: "var(--ma-sky)" },
  hidden: { id: "hidden", label: "Hidden", color: "var(--ma-ink)" },
};

export interface Venue {
  id: string;
  name: string;
  cat: CategoryId;
  neigh: string;
  x: number;
  y: number;
  lat?: number;
  lng?: number;
  live: boolean;
  now: string;
  price: string;
  about?: string;
  address?: string;
  addressFull?: string;
  hoursToday?: string;
  established?: number;
  capacity?: number;
  coverKey?: string | null;
  coverUrl?: string | null;
}

export interface ImportedEvent {
  id: string;
  source: string;
  url: string;
  title: string;
  description?: string | null;
  imageUrl?: string | null;
  category?: CategoryId | null;
  neighborhood?: string | null;
  rawTags: string[];
  startsAtText?: string | null;
  startsAt?: number | null;
  endsAt?: number | null;
  address?: string | null;
  lat?: number | null;
  lng?: number | null;
  geocodeSource?: "scrape" | "nominatim" | null;
  /** Admin-set "don't surface to consumers" flag. Public endpoints
   *  filter `hidden = 1` rows out; only /api/admin/events returns them. */
  hidden?: boolean;
}

export interface VenueEvent {
  id: string;
  venueId: string;
  title: string;
  startsAt: number;
  endsAt: number;
  description?: string;
  price?: string;
}

export interface Friend {
  id: string;
  name: string;
  handle: string;
  avatarInitial: string;
  avatarTone: string;
  activeNow?: { venueId: string; venueName: string; at: number } | null;
}

export interface List {
  id: string;
  name: string;
  tone: string;
  count: number;
  updatedAt: number;
  cover: string[];
}

export interface CheckinFeedItem {
  id: string;
  type: "checkin" | "now" | "list" | "photo";
  name: string;
  initial: string;
  tone: string;
  venueId?: string;
  venueName?: string;
  cat?: CategoryId;
  time: string;
  note?: string;
  listName?: string;
  n?: number;
  live?: boolean;
}

export interface User {
  id: string;
  email: string;
  name: string;
  handle: string;
  avatarInitial: string;
  avatarTone: string;
  neighborhood?: string;
  role: "user" | "admin";
  interests: CategoryId[];
}
